module.exports = __webpack_public_path__ + "static/media/CodedValues.df4e51ad.txt";